import { Component, Inject, OnInit, Optional } from '@angular/core';
import { LayoutService } from '@app/core/services/layout.service';
import { UtilityService } from '@app/core/services/utility.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator, useNavigatorFor } from '@app/modal/state-modal/state-modal.component';
import { P2UpdateTableItem, P2UpdateTableService, P2UpdateTablesSettingsGet } from '@app/services/p2-update-table.service';

@Component({
    selector: 'tt-p2-update-tables',
    templateUrl: './p2-update-tables.component.html',
    styleUrls: ['./p2-update-tables.component.css'],
    standalone: false,
})
export class P2UpdateTablesComponent implements OnInit {
    public readonly tabletSize: MediaQueryList;

    public setting?: P2UpdateTablesSettingsGet;

    public itemState = '';

    public p2UpdateTableKeyno = '';

    public tables: P2UpdateTableItem[] = [];

    private navigator?: TTViewNavigator;

    constructor(
        private p2UpdateTable: P2UpdateTableService,
        private utility: UtilityService,
        layout: LayoutService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) navigator?: TTViewNavigator,
    ) {
        this.tabletSize = layout.getMediaQueries().tablet;
        this.navigator = useNavigatorFor(navigator, this);
    }

    public async loadTables(): Promise<void> {
        const [setting, tables] = await Promise.all([
            this.p2UpdateTable.getSettings(),
            this.p2UpdateTable.listUpdateTables(),
        ]);

        this.setting = { ...setting, filtervalue: setting.filtervalue ?? '' };
        this.tables = tables;
        this.itemState = this.tables.reduce((state, item) => item.item_state || state, '');
    }

    public async updateList(): Promise<void> {
        this.p2UpdateTableKeyno = '';
        this.tables = await this.p2UpdateTable.listUpdateTables();
        this.itemState = this.tables.reduce((state, item) => item.item_state || state, '');
    }

    public openTable(item: P2UpdateTableItem, event?: MouseEvent): void {
        if (this.tabletSize.matches && this.itemState === 'p2updatetableedit') {
            this.p2UpdateTableKeyno = `${item.item_id}`;
            return;
        }

        this.navigateToEdit(`${item.item_id}`, event);
    }

    public createTable(event?: MouseEvent): void {
        if (this.tabletSize.matches && this.itemState === 'p2updatetableedit') {
            this.p2UpdateTableKeyno = '0';
            return;
        }

        this.navigateToEdit('0', event);
    }

    public ngOnInit(): void {
        void this.loadTables();
    }

    private navigateToEdit(keyno: string, event?: MouseEvent): void {
        const target = { to: 'p2updatetableedit', parms: { p2_updatetable_keyno: keyno } };

        if (event && this.navigator && this.utility.isModifierKeyPressed(event)) {
            void this.navigator.newTab(target);
        } else {
            void this.navigator?.go(target);
        }
    }
}
